<template>
    <div class="app-wrapper">
      <ResponsiveNavbar />
      <main class="main-content">
        <VacatureTotaal />
        <ContactUs />
      </main>
      <Footer />
    </div>
  </template>
  
  <script>
  import ResponsiveNavbar from "@/components/Navbar.vue";
  import ContactUs from "@/components/ContactUs.vue";
  import Footer from "@/components/Footer.vue";
  import VacatureTotaal from "@/components/Vactotaal.vue";
  
  export default {
    name: "VacaturePagina",
    components: {
      ResponsiveNavbar,
      VacatureTotaal,
      ContactUs,
      Footer,
    },
  };
  </script>
  
  <style scoped>
  /* Voeg styling naar wens toe */
  </style>
  